/* eslint-disable import/prefer-default-export */
import { isSocialWebLike } from 'utils/contentTypeUtil'
import FirehoseStatus from 'enums/FirehoseStatus'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { DashboardWidgetData } from 'features/widget/types'
import MeasureType from 'enums/MeasureType'
import { SummaryMetricsType } from '../../types'

export const isProjectedTopic = (selectedTopic: SummaryMetricsType['selectedTopic']) => {
  if (!selectedTopic) return false

  const { fhTwitterStatus, scale, contentType, sampledGIIndex } = selectedTopic
  const isFirehoseStatusOff = fhTwitterStatus === FirehoseStatus.OFF

  return isSocialWebLike(contentType!) && ((isFirehoseStatusOff && scale) || sampledGIIndex)
}

export const getMetricDataset = (
  serviceResult: DashboardWidgetData<AnnotatedMetricResult>,
  index: number
) => serviceResult.results![index].data.metrics![0].dataset!

export const isVocMetrics = (category: string) =>
  [
    MeasureType.OVERALL_STAR_RATINGS,
    MeasureType.OVERALL_SURVEY_SCORES,
    MeasureType.NET_PROMOTER_SCORES
  ].includes(category)
